class LanguageNotAvailableModal {
    constructor() {
        this.modal = document.querySelector('.modal-language-not-available');
        this.closeButton = this.modal?.querySelector('.btnCloseLanguageNotAvailable');
        this.stayButton = this.modal?.querySelector('.btnStayOnPage');
        this.goToListingLink = this.modal?.querySelector('.btnGoToLanguageListing');
        this.titleEl = this.modal?.querySelector('[data-language-not-available-title]');
        this.notAvailableMessageEl = this.modal?.querySelector('[data-language-not-available-message]');
        this.listingMessageEl = this.modal?.querySelector('[data-language-listing-message]');
        this.stayButtonLabelEl = this.modal?.querySelector('[data-language-not-available-stay]');

        if (!this.modal || !this.closeButton || !this.stayButton || !this.goToListingLink) return;

        this.strings = this.parseStrings();

        this.bindEvents();
        this.bindLanguageSwitcher();
    }

    parseStrings() {
        const el = document.getElementById('language-not-available-i18n');

        if (!el) return {};

        try {
            return JSON.parse(el.textContent);
        } catch (e) {
            return {};
        }
    }

    open(url, locale) {
        const strings = this.strings[locale];

        this.goToListingLink.setAttribute('href', url);

        if (strings) {
            if (this.titleEl) this.titleEl.textContent = strings.title;
            if (this.notAvailableMessageEl) this.notAvailableMessageEl.textContent = strings.message;
            if (this.listingMessageEl) this.listingMessageEl.textContent = strings.cta;
            if (this.stayButtonLabelEl) this.stayButtonLabelEl.textContent = strings.stay;
            this.closeButton.setAttribute('title', strings.close);
            this.closeButton.setAttribute('aria-label', strings.close);
        }

        this.modal.classList.add('active');
        this.modal.removeAttribute('aria-hidden');
        this.modal.removeAttribute('inert');
        document.body.classList.add('overflow-hidden');
        window.setTimeout(() => this.closeButton.focus(), 120);
    }

    close() {
        this.modal.classList.remove('active');
        this.modal.setAttribute('aria-hidden', 'true');
        this.modal.setAttribute('inert', '');
        document.body.classList.remove('overflow-hidden');
    }

    bindEvents() {
        this.closeButton.addEventListener('click', () => this.close());
        this.stayButton.addEventListener('click', () => this.close());

        this.modal.addEventListener('click', event => {
            if (event.target === this.modal) this.close();
        });

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && this.modal.classList.contains('active')) {
                this.close();
            }
        });
    }

    bindLanguageSwitcher() {
        document.addEventListener('click', event => {
            const link = event.target.closest('[data-lang-unavailable]');
            if (!link) return;

            event.preventDefault();
            this.open(link.getAttribute('href'), link.dataset.lang);
        });
    }
}

new LanguageNotAvailableModal();
